import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ItemToFilterShared } from '../../../models/interface/itemToFilter.interface';
import { Filters } from '../../../types/filters.type';

@Component({
  selector: 'app-mu-select-button',
  templateUrl: './mu-select-button.component.html',
  styleUrls: ['./mu-select-button.component.sass'],
})
export class MuSelectButtonComponent<TargetFilters> implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() controlName: string;
  @Input() options: ItemToFilterShared[];
  @Input() filterList: Filters<TargetFilters>;
  @Input() filterName: string;
  @Input() circleSkin = false;
  @Input() multiple = true;
  @Input() customClass: string;
  @HostBinding('class') baseClass: string;

  constructor() {
    this.baseClass = 'mu-select-buttons';
  }

  ngOnInit(): void {
    /** */
  }
}
